import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { Column } from 'further-ui/components/Layout';

type Props = {
  label: string;
  value: string;
  description: string;
};

const CapitalActionsSummaryStat: FC<Props> = ({
  label,
  value,
  description,
}) => {
  return (
    <Column spacing="xs" flex={1}>
      <Typography variant="h6">{label}</Typography>
      <Typography variant="body2" color="grey.900">
        {value}
      </Typography>
      <Typography variant="body2">{description}</Typography>
    </Column>
  );
};

export default CapitalActionsSummaryStat;
